import React, { useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { DoubleListBoxContext } from '@bingads-webui-react/double-list-box-fluent';
import { CampaignOData } from '@bingads-webui-react/campaign-odata';
import { notificationApi } from '@bingads-webui-campaign/notification-center';
import { DataSource } from './data-source';
import { useCampaignFiltering } from '../../../hooks';

export const CampaignData = ({ coupon }) => {
  const i18n = useContext(I18nContext);

  const {
    state: {
      search,
    },
  } = useContext(DoubleListBoxContext);

  const {
    campaignTypeFiltering, biddingStrategyTypeFiltering, search: campaignSearch, and,
  } = useCampaignFiltering(coupon);

  const campaignSelectionConfigs = useMemo(() => {
    const baseConfigs = {
      top: 1000,
      select: ['Id', 'Name'],
      orderby: { Name: 1 },
      filter: {
        where: and(campaignTypeFiltering, biddingStrategyTypeFiltering),
      },
    };

    if (search) {
      baseConfigs.filter.where = and(baseConfigs.filter.where, campaignSearch(search));
    }

    return baseConfigs;
  }, [and, biddingStrategyTypeFiltering, campaignSearch, campaignTypeFiltering, search]);

  return (
    <CampaignOData
      call={({ currentAccount }) => currentAccount.Campaigns.get(campaignSelectionConfigs)}
      fallback={() => <DataSource campaignData={{ value: [] }} />}
      onError={() => {
        notificationApi.showWarning(i18n.getString(_TL_('Microsoft Advertising problem, try again later.')));
        return () => (<DataSource campaignData={{ value: [] }} />);
      }}
    >
      {campaignLoadResult => (<DataSource campaignData={campaignLoadResult} />)}
    </CampaignOData>
  );
};

CampaignData.propTypes = {
  coupon: PropTypes.shape({
    FeatureId: PropTypes.number.isRequired,
  }).isRequired,
};
